import { ColumnDef } from '@tanstack/react-table';
import lodashGet from 'lodash.get';
import { TableTrophy } from '../core/table-creator';

/**
 * Calculates trophy values (min/max) for columns
 */
export const calculateTrophyColumns = (
  columns: ColumnDef<any, any>[],
  data: any[]
) => {
  // Filter out rows that should be excluded from trophy calculations
  const compareData = data.filter((row) => !row.excludeFromTrophy);

  return columns.reduce((acc, column: any) => {
    if (column?.meta?.trophy === TableTrophy.HIGHEST) {
      acc[column.accessorKey] = Math.max(
        ...compareData.map((row) => lodashGet(row, column.accessorKey))
      );
    } else if (column?.meta?.trophy === TableTrophy.LOWEST) {
      acc[column.accessorKey] = Math.min(
        ...compareData.map((row) => lodashGet(row, column.accessorKey))
      );
    }

    return acc;
  }, {} as Record<string, any>);
};
